import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	Output
} from '@angular/core';
import type { BaseMarker, Marker } from '@go-modules/interfaces/markers/marker';
import * as Color from 'color';
import { TranslateService } from '@ngx-translate/core';
import { NgxFeatureFlagService } from '@go-modules/services/feature-flag/feature-flag.service';

@Component({
	selector: 'marker',
	templateUrl: './marker.component.html',
	styleUrls: ['./marker.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class MarkerComponent {
	@Input() public marker: Marker | BaseMarker;
	@Input() public showButton: boolean = false;
	@Input() public withName: boolean = false;
	@Input() public disabled: boolean = false;
	@Input() public showRemove: boolean = false;
	@Input() public aiStyle: boolean = false;
	@Input() public withCount: boolean = false;
	@Output() public select: EventEmitter<any> = new EventEmitter(); // eslint-disable-line @angular-eslint/no-output-native
	@Output() public remove: EventEmitter<any> = new EventEmitter();

	constructor (
		public featureFlagService: NgxFeatureFlagService,
		private translate: TranslateService
	) {}

	public getLabel (marker) {
		if (this.withCount) {
			return this.translate.instant('marker-display_marker-with-count', {
				name: marker.tag_name,
				count: marker.count
			});
		}
		return marker.tag_name;
	}

	public bestContrast () {
		const color = Color('#' + this.marker.tag_color);
		return color.contrast(Color('#ffffff')) > color.contrast(Color('#333333')) ? '#ffffff' : '#333333';
	}
}
